
const downloadFormVisible = () => {

    const sections = document.querySelectorAll(".s-download");

    sections.forEach(section => {
        const buttons = section.querySelectorAll(".s-download__form-button");
        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const body = document.querySelector("body");
                const form = section.querySelector(".s-download__form")
                form.classList.add("--js-open");
                body.classList.add("--opened-modal");
            })
        });
    });
}


const downloadFormHidden = () => {

    const sections = document.querySelectorAll(".s-download");
    sections.forEach(section => {
        const closes = section.querySelectorAll(".s-download__form");
        closes.forEach(close => {
            close.addEventListener("click", (e) => {
                const element = e.target as HTMLElement

                if (element.classList.contains("f-offer__close") || element === close) {
                    const body = document.querySelector("body");
                    close.classList.remove("--js-open")
                    body.classList.remove("--opened-modal");
                }
            })
        });
    });
}

downloadFormVisible();
downloadFormHidden();
